/* eslint-disable import/no-unassigned-import */
import 'swiper/css';
import 'swiper/css/pagination';

import Swiper from 'swiper';
import { Autoplay,Navigation, Pagination  } from 'swiper/modules';

import { type App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Retail Home Header Component');

    app.afterMount
        .then(() => {
            mountRetailHomeHeader();
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Retail Home Header Component', error);
        });
};


/**
 *  @function mountRetailHomeHeader
 *  @description Mounts the Retail Home Header component and inits swiper
*/

function mountRetailHomeHeader() {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const swiper = new Swiper('div[data-retail-home-swiper]', {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        slidesPerView: 'auto',
        speed: 1000,
        autoplay: {
            delay: 2000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true
        },
        // direction:'vertical', // uncomment these two properties
        // breakpoints: {        // to enable vert on xs - sm
        //     768: {            // and horizontal on md +
        //         direction: 'horizontal'
        //     }
        // }
    });

}
